import React, { useState, useEffect } from "react";
import { TextField, Button, MenuItem, Menu, Tooltip } from "@mui/material";
import { Get_One_Nested_Prop_From_MongoDB } from "../../../api/Get_One_Nested_Prop_From_MongoDB";
import { useParams } from "react-router-dom";
import { Update_To_MongoDB_By_ID } from "../../../api/Update_To_MongoDB_By_ID";
import removeUnderscores from "../../../../functions/removeUnderscores";
import { StudentuseAuth } from "../../../security/StudentUseAuth";
import { Student_Get_One_Nested_Prop_From_MongoDB } from "../../../api/Student_Get_One_Nested_Prop_From_MongoDB";
import { Student_Update_To_MongoDB_By_ID } from "../../../api/Student_Update_To_MongoDB_By_ID";
import { Link } from "react-router-dom";
import SEFChangePage from "../../../components/ChangePage/SEFChangePage";
import TextFieldForObjectState from "../../../components/Questions/TextFields/TextFieldForObjectState";

import SelectFieldForObjectState from "../../../components/Questions/TextFields/SelectFieldForObjectState";
import CheckConditions from "../../../components/Questions/CheckConditions";
import { Arr_VISAInfo } from "../../../../arrays/SEF/Arr_VISAInfo";
import DisplayTextField from "../../../components/Questions/DisplayTextField";
import getArrayOfQuestionsAndNeededToSubmit from "../../../components/Questions/GetUsefulArrays/getArrayOfQuestionsAndNeededToSubmit";
import { Consultant_Get_One_Nested_Prop_From_MongoDB } from "../../../../Consultants/api/Consultant_Get_One_Nested_Prop_From_MongoDB";
import { ConsultantuseAuth } from "../../../../Consultants/security/ConsultantUseAuth";
import { Consultant_Update_To_MongoDB_By_ID } from "../../../../Consultants/api/Consultant_Update_To_MongoDB_By_ID";
import { Get_One_Choose_Fields_From_MongoDB } from "../../../../Consultants/api/Get_One_Choose_Fields_From_MongoDB";

function ViewSEFVISAInfo() {
  const { id } = useParams();

  let logoutStudent;
  let logoutConsultant;
  if (window.location.href.indexOf("Student") > -1) {
    logoutStudent = StudentuseAuth().logoutStudent;
  } else {
    logoutConsultant = ConsultantuseAuth().logoutConsultant;
  }

  const [formInfo, setformInfo] = useState({});

  //Get all questions for this page
  const { arrayOfQuestions, neededToSubmit } =
    getArrayOfQuestionsAndNeededToSubmit("VISAInfo", formInfo, Arr_VISAInfo);

  const isFormComplete = neededToSubmit.length === 0;

  const [PageButtonStatus, setPageButtonStatus] = useState(false);

  const [SEFProgress, setSEFProgress] = useState({
    VISAInfo: "",
  });

  const [obj_EC, setobj_EC] = useState({});
  const [obj_assignedEC, setobj_assignedEC] = useState({});
  const [StudentData, setStudentData] = useState({});

  useEffect(() => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        "VISA",
        setformInfo,
        logoutStudent
      );
      Student_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        localStorage.getItem("Student_id"),
        "SEFProgress",
        setSEFProgress,
        logoutStudent
      );
    } else {
      Consultant_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        "SEFProgress",
        setSEFProgress,
        logoutConsultant
      );
      Consultant_Get_One_Nested_Prop_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        "VISA",
        setformInfo,
        logoutConsultant
      );

      Get_One_Choose_Fields_From_MongoDB(
        "Registers_2025",
        "All",
        id,
        { IPInfo: 1, VISA: 1, SEFProgress: 1 },
        setStudentData,
        logoutConsultant
      );
    }
  }, []);

  useEffect(() => {
    //if the web page URL contains the string Student
    if (window.location.href.indexOf("Student") > -1) {
    } else {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        {},
        setobj_EC,
        logoutConsultant
      );
      if (StudentData && StudentData._id && StudentData._id.length === 24) {
        Get_One_Choose_Fields_From_MongoDB(
          "IP",
          "EC",
          StudentData.IPInfo?.EC_ID,
          { _id: 1, "MetaData.Agency_id": 1 },
          setobj_assignedEC,
          logoutConsultant
        );
      }
    }
  }, [StudentData]);

  let EC_Check_Permissions = false;
  if (
    localStorage.getItem("Consultant_id") === StudentData.IPInfo?.EC_ID ||
    (obj_EC.MetaData?.Admin === "Yes" &&
      obj_EC.MetaData?.Agency_id === obj_assignedEC.MetaData?.Agency_id)
  ) {
    EC_Check_Permissions = true;
  }
  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setformInfo((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [status, setStatus] = useState(false);

  const handleSaveProgress = () => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Update_To_MongoDB_By_ID(
        {
          VISA: formInfo,
          "SEFProgress.VISAInfo": "In_Progress",
        },
        "Registers_2025",
        "All",
        setStatus,
        localStorage.getItem("Student_id"),

        "Your progress has been saved, you may now navigate to another page using the buttons at the bottom or close this tab",
        logoutStudent
      );
    } else {
      Consultant_Update_To_MongoDB_By_ID(
        {
          VISA: formInfo,
          "SEFProgress.VISAInfo": "In_Progress",
        },
        "Registers_2025",
        "All",
        setStatus,
        id,
        logoutConsultant
      );
    }
    setPageButtonStatus(true);
  };

  const handleSubmit = () => {
    if (window.location.href.indexOf("Student") > -1) {
      Student_Update_To_MongoDB_By_ID(
        {
          VISA: formInfo,
          "SEFProgress.VISAInfo": "Awaiting_Review",
        },
        "Registers_2025",
        "All",
        setStatus,
        localStorage.getItem("Student_id"),

        "This page has been submitted, you may now navigate to another page using the buttons at the bottom or close this tab",
        logoutStudent
      );
    } else {
      Consultant_Update_To_MongoDB_By_ID(
        {
          VISA: formInfo,
          "SEFProgress.VISAInfo": "Awaiting_Review",
        },
        "Registers_2025",
        "All",
        setStatus,
        id,
        logoutConsultant
      );
    }
    setSEFProgress({
      VISAInfo: "Complete",
    });
    setPageButtonStatus(true);
  };

  if (
    window.location.href.indexOf("Student") < 0 &&
    !EC_Check_Permissions &&
    (Object.keys(StudentData).length === 0 ||
      Object.keys(obj_EC).length === 0 ||
      Object.keys(obj_assignedEC).length === 0)
  ) {
    return (
      <div className="view-basic-info-container">
        <h1>Checking Access Permissions...</h1>
      </div>
    );
  } else if (
    window.location.href.indexOf("Student") < 0 &&
    !EC_Check_Permissions
  ) {
    return (
      <div className="view-basic-info-container">
        <h1>Access Denied</h1>
      </div>
    );
  } else {
    return (
      <div className="view-basic-info-container">
        <h1>Summer Information</h1>
        {SEFProgress &&
        SEFProgress.VISAInfo &&
        (SEFProgress.VISAInfo === "Complete" ||
          SEFProgress.VISAInfo === "Awaiting_Review") ? (
          <strong>
            If you need to make further changes, please contact InvestIN at
            info@investin.org or speak to your known contact
          </strong>
        ) : (
          ""
        )}

        <form className="view-basic-info-form">
          <h2>Student VISA Information</h2>
          <p>
            <b>
              Everyone wishing to travel to the UK – except British and Irish
              citizens – will need permission to travel in advance. This can be
              either through an ETA or an eVisa.
            </b>{" "}
            If you are unsure as to whether you need an ETA or an eVisa, please
            review the UK government questionnaire by following{" "}
            <a href="https://www.gov.uk/check-uk-visa" target="_blank">
              <strong>this link.</strong>
            </a>
            <br></br>
            <br></br>Does the student require a confirmation of attendance from
            InvestIN to support their e-visa application to enter the United
            Kingdom for the purpose of attending the summer programme? Please
            note, students attending on an ETA do not need any supporting
            documentation.
          </p>
          {Array.from({ length: 8 }, (_, i) => i).map((i) => (
            <>
              <DisplayTextField
                formInfo={formInfo}
                handleChange={handleChange}
                Object={Arr_VISAInfo[i]}
              />
            </>
          ))}
          {window.location.href.indexOf("Student") > -1 ? (
            <SEFChangePage
              Page={"VISAInfo"}
              PageButtonStatus={PageButtonStatus}
            />
          ) : (
            <></>
          )}
          {isFormComplete ? (
            <></>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>
                    You can save this page at any point. To submit this page,
                    please complete the following questions first:
                  </th>
                </tr>
              </thead>
              <tbody>
                {neededToSubmit.map((Obj) => {
                  return (
                    <tr key={Obj.name}>
                      <td>{Obj.label}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}{" "}
          <h3>
            Once this page is completed and you have completed every question,
            please click "Submit" to complete the page and send it for review by
            InvestIN. Otherwise, click "Save" if you are not ready to complete
            the page and wish to return later to make changes
          </h3>
          <div className="view-basic-info-buttons">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveProgress}
              disabled={
                status ||
                (SEFProgress &&
                  SEFProgress.VISAInfo &&
                  (SEFProgress.VISAInfo === "Complete" ||
                    SEFProgress.VISAInfo === "Awaiting_Review")) ||
                Object.keys(formInfo).length === 0
              }
            >
              Save Progress
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleSubmit}
              disabled={
                !isFormComplete ||
                status ||
                (SEFProgress &&
                  SEFProgress.VISAInfo &&
                  (SEFProgress.VISAInfo === "Complete" ||
                    SEFProgress.VISAInfo === "Awaiting_Review")) ||
                Object.keys(formInfo).length === 0
              }
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

export default ViewSEFVISAInfo;
